<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6 search-criteria">
          <div class="tab style-2" role="tabpanel" style="margin-bottom:20px; box-shadow: none;">
            <ul class="nav nav-tabs" role="tablist" style="border-top: none">
              <li role="presentation" class="active"><a href="#home2" aria-controls="home2" role="tab" data-toggle="tab" style="padding:10px 20px; background-color:gray">{{ $t('jobs.search') }}</a></li>
            </ul>
            <!-- Tab panes -->
            <div class="tab-content tabs" style="border-radius:0px 0px 6px 6px; border: 1px solid #eaeff5;">
              <div role="tabpanel" class="tab-pane fade in active" id="home2">
                <div class="search_widget_job">
                  <div class="field_w_search" style="margin-top:10px;">
                    <input type="text" class="form-control" v-model="keyword" :placeholder="$t('jobs.keyword')">
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <SearchBox id="salary-range" :criteria="salaryRange" :title="$t('jobs.salary-range')" :values.sync="salaries" :filter="false" />

          <!--<SearchBox id="location" :criteria="meta.active_locations" :title="$t('jobs.location')" :values.sync="locations" :filter="true" />-->
          <div class="widget-boxed padd-bot-0">
            <div class="widget-boxed-header br-0">
              <h4>{{ $t('jobs.location') }} <a href="javascript:void(0)" @click="openLocationModal"><i class="pull-right ti-plus" aria-hidden="true"></i></a></h4>
            </div>
          </div>
          
          <SearchBox id="function" :criteria="meta.active_functions" :title="$t('jobs.function')" :values.sync="functions" :filter="true" v-if="this.$route.query.functions_id == undefined" />          

          <SearchBox id="job-type" :criteria="jobType" :title="$t('jobs.job-type')" :values.sync="types" :filter="false" v-if="$route.query.intern !='1'" />
          
          <SearchBox id="work-length" :criteria="workLength" :title="$t('jobs.work-length')" :values.sync="exps" :filter="false" />
          
          <SearchBox id="industry" :criteria="meta.active_industries" :title="$t('jobs.industry')" :values.sync="industries" :filter="true" />

          <SearchBox id="open-date" :criteria="openDate" title="发布日期" :values.sync="od" :filter="false" />

          <SearchBox id="featured" :criteria="featuredJob" :title="$t('jobs.featured')" :values.sync="featured" :filter="false" v-if="this.$route.query.featured == undefined" />

          <div class="row">
            <div class="col-md-12">
              <a class="btn theme-btn btn-block" v-on:click="searchJobs"><span class="ti-filter"></span> {{ $t('jobs.filter') }}</a>
            </div>
          </div>
        </div>
        
        <div class="col-md-7 col-sm-6" v-if="jobs.length > 0">
          <div class="row mrg-bot-20">
            <div class="col-sm-4">
              <h4>{{ total }} {{ $t('jobs.result') }}</h4>
            </div>
            <div class="col-sm-4">
              <a href="javascript:void(0)" class="btn-job theme-btn-outlined" @click="internOnly" v-if="$route.query.intern =='109'">仅显示实习生基地职位</a>
            </div>
            <div class="col-sm-4">
              <div class="fl-right">
                <div class="search-wide">
                  <h5>{{ $t('jobs.view') }}</h5>
                </div>
                <div class="search-wide">
                  <select class="wide form-control" v-model="pageSize" @change="changePageSize()">
                    <option value="10" selected>{{ $t('jobs.p10') }}</option>
                    <option value="20">{{ $t('jobs.p20') }}</option>
                    <option value="50">{{ $t('jobs.p50') }}</option>
                  </select>
                </div>
              </div>              
            </div>
          </div>
      
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <table class="table table-lg table-hover job-title" style="table-layout:fixed">
                <!--<thead>
                  <tr>
                    <th>{{ $t('join.job-title') }}</th>
                    <th>{{ $t('join.location') }}</th>
                    <th>{{ $t('join.open-date') }}</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>-->
                <tbody>
                  <tr v-for="job in jobs" v-bind:key="job.id">
                    <td width="45%">
                      <!--<router-link :to="/jobs/ + job.data.id">-->
                        <img :src="job.data.recruiting_company.photo_url" class="avatar avatar-lg" alt="Avatar" style="float:left"><p class="elli">{{ job.data.title.name }}<br><span class="mng-jb1">{{ job.data.company_desc || job.data.recruiting_company.name.name }}</span><br>
                        <span class="skill-tag" v-if="job.data.featured">{{ $t('jobs.featured') }}</span><span class="new" v-if="isNew(job.data.create_at)">&nbsp;New</span>
                        </p>
                        
                        
                      <!--</router-link>-->
                      
                    </td>
                    <td><i class="ti-location-pin"></i> {{ job.data.work_location !=null ? job.data.work_location.c_fullname : '' }}</td>
                    <td>{{ job.data.create_at | dateFormat1('from', $i18n.locale) }}</td>
                    <td :class="{'isintern': job.data.internFlag, 'ismagex': job.data.isMagex}" :style="jobListRowStyle(job.data.config)">
                    <router-link :to="'/jobs/' + job.data.id" target="_blank" data-toggle="modal" data-target="" class="btn theme-btn-outlined mrg-5">{{ $t('jobs.apply') }}</router-link>
                    </td>  
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          
          <div class="row">
            <div class="col-md-12">
              <Pagination :currentPage.sync="currentPage" :numPerPage.sync="pageSize" :total.sync="total" />
            </div>
          </div>
        </div>
        <div class="col-md-7 col-sm-7" v-else>
          <div class="row mrg-bot-20">
            <!--<img src="/img/ooops.png" />-->
            <h3>{{ $t('jobs.ooops')}} </h3>
          </div>
        </div>
        <div class="col-md-2 col-sm-12">
          <SideAds />
        </div>
      </div>
      <!-- End Row -->
      
    </div>
    <LocationModal :locations="meta.active_locations" :values="locations" @selected="setLocations" />
  </section>
</template>
<style>
span.new {
  color: #d81c00;
}
.widget-boxed {
  margin-bottom:20px;
}
.job-title td {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>
<script>
// @ is an alias to /src
import moment from 'moment'
import SearchBox from '@/components/SearchBox.vue'
import SideAds from '@/components/SideAds.vue'
import Pagination from '@/components/Pagination.vue'
import LocationModal from '@/components/LocationModal.vue'
import jobStyle from '@/utils/job-style'

export default {
  name: 'JobList',
  props: ['meta', 'config'],
  components: {
    SearchBox,
    SideAds,
    Pagination,
    LocationModal
  },
  data: function () {
  return {
    city: [],
    cname: [],
    pageSize: 20,
    keyword: '',
    locations: [],
    salaries: [],
    types: [],
    functions: [],
    exps: [],
    industries: [],
    jobs: [],
    featured: [],
    intern: [],
    od: [],
    internSwitch: false,
    total: 0,
      pages: 0,
      currentPage: 1,
      query: {
        options: {
        page: 0,
        size: 20,
        sort: [{ create_at: 'desc' }]
      },
      query: {
        mandatory_filters: [{"type":"must","filter":{"or":[{"term":{"status":0}},{"term":{"status":1}}]}}]
      }}
  }
  },
  watch: {
    currentPage: function() {
      //console.log(this.currentPage)
      let that = this
      this.query.options.page = this.currentPage - 1
      this.$http.post(this.API_PREFIX + '/api/search/job?recommend=true', this.query).then(function (response) {
    that.jobs = response.data.hits
    that.total = response.data.total
    that.pages = response.data.num_pages
    that.jobs.forEach(job => {
      that.normalizeName(job.data.title)
      if(job.data.recruiting_company)
        that.normalizeCompany(job.data.recruiting_company.name)
      let img = '/img/no-logo.heic',
            photo = null
      if (job.data.recruiting_company)
        photo = job.data.recruiting_company.photo
      else
        job.data.recruiting_company = {'photo_url': null, 'photo': null, 'id': null, 'name': {'name': null}}
      if(photo) {
        let ext = photo.filename.substr(photo.filename.lastIndexOf('.') + 1)
        img = that.IMG_PREFIX + photo.path + '/' + photo.id + '_company_photo_m.' + ext + '?r=' + Math.random()
      }
      job.data.recruiting_company.photo_url = img

      if (job.data.genes != null) {
        if (job.data.genes.client_company != null && job.data.genes.client_company.includes('Rz'))
          job.data.featured = true
        if (job.data.genes.client_company != null && job.data.genes.client_company.includes('Qk'))
          job.data.internFlag = true
        if (job.data.genes.hirer != null && job.data.genes.hirer.includes('qN'))
          job.data.isMagex = true
      }
      if (job.data.genes != null) {
        //console.log(that.getConfig(job.data))
        job.data.config = that.getConfig(job.data)
      }
    });
    }).catch(err => console.error(err))
    },
    "$route.query": function() {
        //console.log(val)
        this.initQuery()
        /* route param to update data
      */
      let function_id = this.$route.query.function_id || '0',
        salary = this.$route.query.salary || '0',
        keyword = this.$route.query.keyword || '',
        location_id = this.$route.query.location_id || '0',
        featured = this.$route.query.featured || '0',
        intern = this.$route.query.intern || '0',
        functions_id = this.$route.query.functions_id || '0',
        locations_id = this.$route.query.locations_id || '0'
      if (keyword != '') {
        this.keyword = decodeURI(keyword)
      this.query.query.query_string = decodeURI(keyword)
    }
    if (salary != '0') {
      this.query.query.mandatory_filters.push(
        this.parseSalaryQuery(salary).filter)
    }
      if (function_id != '0') {
        //this.functions.push(function_id)
        let t = this.meta.active_functions.find(function(obj) {
          return obj.id === function_id
        })
        this.query.query.mandatory_filters.push({
          type: 'must',
          filter: {
            or: [
              { terms: { 'job_function.id': t.functions_ids }},
              { terms: { 'job_function.function_id': t.functions_ids }},
              { terms: { 'job_function.function_group_id': t.functions_ids }}
            ]
          }
        })
      }
      if (functions_id != '0') {
        let f = functions_id.split(',')
        this.functions = f
        
        this.query.query.mandatory_filters.push({
          type: 'must',
          filter: {
            or: [
              { terms: { 'job_function.id': f }},
              { terms: { 'job_function.function_id': f }},
              { terms: { 'job_function.function_group_id': f }}
            ]
          }
        })
      }
      if (locations_id != '0') {
        this.locations = locations_id.split(',')
        let locs = this.locations.filter(id => id != 'overseas')
        let branches = []
        if (locs.length > 0) {
          branches.push({ terms: { 'work_location.id': locs }})
          branches.push({ terms: { 'work_location.province_id': locs }})
          branches.push({ terms: { 'work_location.country_id': locs }})
        }
        // 全部国外: not China but has a location; an OR branch so 国内∪国外 is a union
        if (this.locations.indexOf('overseas') != -1) {
          branches.push({ and: [
            { not: { terms: { 'work_location.country_id': [1, 369, 370, 371] } } },
            { exists: { field: 'work_location.id' } }
          ]})
        }
        if (branches.length > 0) {
          this.query.query.mandatory_filters.push({
            type: 'must',
            filter: { or: branches }
          })
        }
      }
      if (location_id != '0') {
        this.locations.push(location_id)
      this.query.query.mandatory_filters.push({
        type: 'must',
        filter: {
          or: [
            { term: { 'work_location.id': location_id }},
            { term: { 'work_location.province_id': location_id }},
            { term: { 'work_location.country_id': location_id }}
          ]
        }
      })
    }
    if (featured == '1') {
      //console.log(this.featured.length)
      if (this.featured.length == 0)
        this.featured.push(1)
      this.query.query.mandatory_filters.push({type:"must", filter: {term : {'genes.client_company':'Rz'}}})
    } else {
      this.featured = []
    }

    if (intern == '1') {
      this.resetSearch()
      if (this.intern.length == 0)
        this.intern.push(1)
      this.query.query.mandatory_filters.push({type:"must", filter: {term : {'job_type':'intern'}}})
      this.query.query.mandatory_filters.push({type:"must_not", filter: {term : {'hirer_id':'18222'}}})
    } else {
        this.intern = []
    }
    this.updateJobs(this.query)
    }
  },
  computed: {
    isLogedIn: function() {
      return this.$store.state.user != null
    },
    loginUrl: function() {
      let url = this.API_PREFIX + '/api/acca/signin?redirect_url=' + encodeURIComponent(this.API_PREFIX + '/home/#' + this.$route.path)
      return url
    },
    pageSizeValue: function() {
      return this.pageSize
    }
  },
  methods: {
    jobListRowStyle: jobStyle.jobListRowStyle,
    getConfig: function(v) {
      return jobStyle.getConfig(v, this.config)
    },
    resetSearch() {
      this.currentPage = 1
      this.keyword = ''
      this.locations = []
      this.salaries = []
      this.types = []
      this.functions = []
      this.exps = []
      this.industries = []
      this.intern = []
      this.featured = []
    },
    isNew: function(date) {
      if (moment(date).add(7, 'day') > moment())
        return true
      return false
    },
    internOnly: function() {
      this.internSwitch = true
      this.searchJobs()
    },
    setLocations: function(c) {
      this.locations = []
      //this.cname = []
      for (let i = 0; i < c.length; i ++) {
        // 热门城市全选 carries all hot ids joined; split so each becomes a term
        String(c[i].id).split(',').forEach(id => this.locations.push(id))
        //this.cname.push(c[i].name)
      }
      /*if (c.length > 0) {
        this.cityNames = this.cname.join(',')
      } else
        this.cityNames = null*/
    },
    openLocationModal: function() {
      this.$nextTick (function () {
      $('#location-modal').modal('show')
    })
    },
    login: function() {
      if (!this.isLogedIn)
        window.location = this.loginUrl
    },
    initQuery: function() {
      this.query = {
        options: {
        page: 0,
        size: 20,
        sort: [{ create_at: 'desc' }]
      },
      query: {
        mandatory_filters: [{"type":"must","filter":{"or":[{"term":{"status":0}},{"term":{"status":1}}]}}]
      }}
    },
    changePageSize: function() {
      this.query.options.size = this.pageSize
      this.updateJobs(this.query)
    },
    searchJobs: function() {
      let filter = {
      options: {
        page: 0,
        size: 20,
        sort: [{ create_at: 'desc' }]
      },
      query: {
        mandatory_filters: [{"type":"must","filter":{"or":[{"term":{"status":0}},{"term":{"status":1}}]}}]
      }
    }
    if (this.keyword) {
      filter.query.query_string = this.keyword;
    }
    if (this.salaries.length > 0) {
      filter.query.mandatory_filters.push(
          this.parseSalaryQuery(this.salaries).filter)
    }
    if (this.locations.length > 0) {
      let locs = this.locations.filter(id => id != 'overseas')
      let branches = []
      if (locs.length > 0) {
        branches.push({ terms: { 'work_location.id': locs }})
        branches.push({ terms: { 'work_location.province_id': locs }})
        branches.push({ terms: { 'work_location.country_id': locs }})
      }
      // 全部国外: not China but has a location; an OR branch so 国内∪国外 is a union
      if (this.locations.indexOf('overseas') != -1) {
        branches.push({ and: [
          { not: { terms: { 'work_location.country_id': [1, 369, 370, 371] } } },
          { exists: { field: 'work_location.id' } }
        ]})
      }
      if (branches.length > 0) {
        filter.query.mandatory_filters.push({
          type: 'must',
          filter: { or: branches }
        })
      }
    }
    if (this.types.length > 0) {
      filter.query.mandatory_filters.push({
        type: 'must',
        filter: {
          terms: { job_type: this.types }
        }
      })
    }
    if (this.functions.length > 0) {
      let functions_id = this.$route.query.functions_id || '0'
      let f1 = []
      if (functions_id == '0') {
        
        for (let i = 0; i < this.functions.length; i++) {

            let fid = this.functions[i]
            let t = this.meta.active_functions.find(function(obj) {
                return obj.id === parseInt(fid)
            })
            //console.log(t.functions_ids)
            if (t)
              f1 = f1.concat(t.functions_ids)
            //console.log(f1)
        }
    } else {
      
      f1 = functions_id.split(',')
      //console.log(f1)
    }
      filter.query.mandatory_filters.push({
        type: 'must',
        filter: {
          or: [
            { terms: { 'job_function.id': f1 }},
            { terms: { 'job_function.function_id': f1 }},
            { terms: { 'job_function.function_group_id': f1 }}
          ]
        }
      })

    }
    if (this.exps.length > 0) {
      filter.query.mandatory_filters.push(
          this.parseExpQuery(this.exps).filter)
    }
    if (this.industries.length > 0) {
      filter.query.mandatory_filters.push({
        type: 'must',
        filter: {
          or: [
            { terms: { 'industries.id': this.industries }},
            { terms: {
              'industries.category_id': this.industries
            }},
          ]
        }
      });
    }
    if (this.featured.length > 0) {
      filter.query.mandatory_filters.push({type:"must", filter: {term : {'genes.client_company':'Rz'}}})
    }
    if (this.intern.length > 0) {
      filter.query.mandatory_filters.push({type:"must", filter: {term : {'job_type':'intern'}}})
    filter.query.mandatory_filters.push({type:"must_not", filter: {term : {'hirer_id':'18222'}}})
    }
    if (this.od.length > 0) {
      filter.query.mandatory_filters.push({type:"must", filter: {range : {'create_at':{'ge': this.od[0]}}}})
    }
    //only intern
    if (this.internSwitch) {
      filter.query.mandatory_filters.push({type:"must", filter: {term : {'genes.client_company':'Qk'}}})
    }
    this.updateJobs(filter)
    },
    updateJobs: function(query) {
      let that = this
      if (!query || !query.query ) {
        query = {
          options: {
            page: 0,
            size: 20,
            sort: [{ create_at: 'desc' }]
          },
          query: {
            mandatory_filters: []
          }
        }
      }
      this.query = query
      this.$http.post(this.API_PREFIX + '/api/search/job?recommend=true', query).then(function (response) {
        that.jobs = response.data.hits
        that.total = response.data.total
        that.pages = response.data.num_pages
        that.jobs.forEach(job => {
        that.normalizeName(job.data.title)
        if(job.data.recruiting_company)
          that.normalizeCompany(job.data.recruiting_company.name)
        let img = '/img/no-logo.heic', photo = null
        if (job.data.recruiting_company)
          photo = job.data.recruiting_company.photo
        else
          job.data.recruiting_company = {'photo_url': null, 'photo': null, 'id': null, 'name': {'name': null}}
        if(photo) {
          let ext = photo.filename.substr(photo.filename.lastIndexOf('.') + 1)
          img = that.IMG_PREFIX + photo.path + '/' + photo.id + '_company_photo_m.' + ext + '?r=' + Math.random()
        }

        job.data.recruiting_company.photo_url = img

        if (job.data.genes != null) {
          if (job.data.genes.client_company != null && job.data.genes.client_company.includes('Rz'))
            job.data.featured = true
          if (job.data.genes.client_company != null && job.data.genes.client_company.includes('Qk'))
            job.data.internFlag = true
          if (job.data.genes.hirer != null && job.data.genes.hirer.includes('qN'))
            job.data.isMagex = true
        }
        if (job.data.genes != null) {
          job.data.config = that.getConfig(job.data)
        }
    });
    }).catch(err => console.error(err));
    },
  },
  created: function() {
    /* route param to update data
    */
    let function_id = this.$route.query.function_id || '0',
      salary = this.$route.query.salary || '0',
      keyword = this.$route.query.keyword || '',
      location_id = this.$route.query.location_id || '0',
      featured = this.$route.query.featured || '0',
      intern = this.$route.query.intern || '0',
      locations_id = this.$route.query.locations_id || '0',
      functions_id = this.$route.query.functions_id || '0'
    this.internSwitch = false
    if (keyword != '') {
      this.keyword = decodeURI(keyword)
    this.query.query.query_string = decodeURI(keyword)
  }
  if (salary != '0') {
    this.query.query.mandatory_filters.push(
      this.parseSalaryQuery(salary).filter)
  }
    if (function_id != '0') {
      //this.functions.push(function_id)
      let t = this.meta.active_functions.find(function(obj) {
        return obj.id === function_id
      })
      this.query.query.mandatory_filters.push({
        type: 'must',
        filter: {
          or: [
            { terms: { 'job_function.id': t.functions_ids }},
            { terms: { 'job_function.function_id': t.functions_ids }},
            { terms: { 'job_function.function_group_id': t.functions_ids }}
          ]
        }
      })
    }
    if (functions_id != '0') {
      let f = functions_id.split(',')
      this.functions = f

      this.query.query.mandatory_filters.push({
        type: 'must',
        filter: {
          or: [
            { terms: { 'job_function.id': f }},
            { terms: { 'job_function.function_id': f }},
            { terms: { 'job_function.function_group_id': f }}
          ]
        }
      })
    }
    if (locations_id != '0') {
      this.locations = locations_id.split(',')
      let locs = this.locations.filter(id => id != 'overseas')
      let branches = []
      if (locs.length > 0) {
        branches.push({ terms: { 'work_location.id': locs }})
        branches.push({ terms: { 'work_location.province_id': locs }})
        branches.push({ terms: { 'work_location.country_id': locs }})
      }
      // 全部国外: not China but has a location; an OR branch so 国内∪国外 is a union
      if (this.locations.indexOf('overseas') != -1) {
        branches.push({ and: [
          { not: { terms: { 'work_location.country_id': [1, 369, 370, 371] } } },
          { exists: { field: 'work_location.id' } }
        ]})
      }
      if (branches.length > 0) {
        this.query.query.mandatory_filters.push({
          type: 'must',
          filter: { or: branches }
        })
      }
    }
    if (location_id != '0') {
      this.locations.push(location_id)
    this.query.query.mandatory_filters.push({
      type: 'must',
      filter: {
        or: [
          { term: { 'work_location.id': location_id }},
          { term: { 'work_location.province_id': location_id }},
          { term: { 'work_location.country_id': location_id }}
        ]
      }
    })
  }
  if (featured != '0') {
    if (this.featured.length == 0)
    this.featured.push(1)
    this.query.query.mandatory_filters.push({type:"must", filter: {term : {'genes.client_company':'Rz'}}})
  } else {
    this.featured = []
  }
  if (intern == '1') {
    this.resetSearch()
    if (this.intern.length == 0)
      this.intern.push(1)
    this.query.query.mandatory_filters.push({type:"must", filter: {term : {'job_type':'intern'}}})
    this.query.query.mandatory_filters.push({type:"must_not", filter: {term : {'hirer_id':'18222'}}})
  } else {
    this.intern = []
  }
  this.updateJobs(this.query)
  }
}
</script>